import { all, select, takeLatest } from 'redux-saga/effects';

import { INIT_APP } from 'src/store/view/constants';

// Helpers:
import { getLocalizationValues } from '@lt/localization/dist/utils/getValuesFromBackend';
import TrackerParsers from 'src/routes/SearchPage/helpers/hitStoreTrackerParsers';
import { getFilters } from 'src/routes/SearchPage/selectors/filtersBase';
import {
  getParams,
  getRequestId,
} from 'src/routes/SearchPage/selectors/searchParams';
import {
  getSortField,
  getSortOrder,
} from 'src/routes/SearchPage/selectors/sorting';

import { pushCcxPageview } from 'src/routes/SeoApp/utils/gtmEvents';
import { searchTypeSelector } from 'src/store/view/selectors';
import { FILTRATION_SUCCESS } from '../filters/constants';
import {
  getHotelsIds,
  getHotelsTourIds,
  getHotelsList,
  getHotelsSurchargesByLevel,
  getHotelsAccommodationAvailability,
  getHotelsFlightSeats,
  getHotelsCount,
} from '../hotels/selectors';
import { paginationSuccessAction } from '../hotels/actions';

/**
 * import { pushCcxPageview } from 'src/routes/SeoApp/utils/gtmEvents';
 * Отправляет данные в Travel Analytics.
 * @param action
 * @param isForce
 * @returns {Object}
 */
function* trackSearchCompleteEvent() {
  try {
    let searchParams = yield select(getParams);

    if (!searchParams) {
      return;
    }

    const hotelsList = yield select(getHotelsList);
    const hotelIds = yield select(getHotelsIds);
    const hotelTourIds = yield select(getHotelsTourIds);
    const hotelSurchargesByLevel = yield select(getHotelsSurchargesByLevel);
    const accommodationAvailability = yield select(
      getHotelsAccommodationAvailability,
    );
    const flightSeats = yield select(getHotelsFlightSeats);
    const sortField = yield select(getSortField);
    const sortOrder = yield select(getSortOrder);
    const localization = getLocalizationValues();
    const originalSortBy = [sortField, sortOrder].join(',');

    searchParams = searchParams.merge({
      hotel_ids: hotelIds,
      tour_ids: hotelTourIds,
      surcharges_by_level: hotelSurchargesByLevel,
      accommodation_availability: accommodationAvailability,
      flight_seats: flightSeats,
    });
    const dataLayerParams = {
      search_params: TrackerParsers.parseTourSearchImmutableParams({
        filterParams: yield select(getFilters),
        requestId: yield select(getRequestId),
        result: hotelsList,
        hotelsCount: yield select(getHotelsCount),
        status: undefined, // на explore нет searchStatus
        sortBy: sortField,
        sortOrder: yield select(getSortOrder),
        searchParams,
        searchType: yield select(searchTypeSelector),
        originalSortBy,
        localization,
      }),
    };

    pushCcxPageview(dataLayerParams);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
}

export default function* SeoAppAnalyticsWatcher() {
  yield all([
    yield takeLatest(
      [INIT_APP, FILTRATION_SUCCESS, paginationSuccessAction.type],
      trackSearchCompleteEvent,
    ),
  ]);
}
